import { useCrudActions } from '@/common/view/useCrudActions';
import { useArenaItemMixins } from '@/modules/arena/item/model/mixins';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { arenaService } from '@/services/arena';
import { onMounted } from 'vue';

export function useArenaItemDetail() {
    const { confirmAndDisable, confirmAndEnable, confirmAndRemove } = useCrudActions();
    const { fetchAllMatches, gameMatchCache } = useGameMatchList();
    const { model, fetch } = useArenaItemMixins();

    const actions = {
        enable: confirmAndEnable({ request: arenaService.item.enable, onSuccess: fetch }),
        disable: confirmAndDisable({ request: arenaService.item.disable, onSuccess: fetch }),
        remove: confirmAndRemove({ request: arenaService.item.remove, onSuccess: fetch })
    };

    onMounted(async () => {
        await fetchAllMatches();
        await fetch();

        model.matchName = gameMatchCache.value.get(model.matchId)?.label || '';
    });

    return { model, actions };
}
